module.exports = __webpack_public_path__ + "img/man.db1a3fc1.svg";